import { useAppSelector } from '@/hooks/use-app-selector'
import { clearReportData } from '@/states/axiomReport.slice'
import { useAppDispatch } from '@hooks/use-app-dispatch'
import { IPageHeaderPropTypes } from '@interfaces/interfaces'
import { ArrowBack } from '@mui/icons-material'
import {
  Box,
  Divider,
  IconButton,
  Stack,
  SvgIcon,
  Typography,
} from '@mui/material'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export const PageHeader: React.FunctionComponent<IPageHeaderPropTypes> = ({
  title,
  icon,
  children,
  variant,
  iconState,
  iconAction,
  childrenPosition,
  showBackButton,
}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useAppDispatch()
  const selectedReport = useAppSelector((s) => s.axiomReport.selectedReport)

  const handleBackClick = () => {
    if (selectedReport && !location.pathname.includes('dashboard')) {
      const newLocation = `/reports/${selectedReport.reportId}/${selectedReport.reportType?.toLowerCase()}/dashboard`
      navigate(newLocation)
    } else {
      navigate('/reports')
      dispatch(clearReportData())
    }
  }
  return (
    <Box display='grid' width='100%' boxSizing='border-box'>
      <Stack
        direction='row'
        alignItems='center'
        boxSizing='border-box'
        justifyContent={childrenPosition || 'space-between'}
        gap={4}
        py={2}
      >
        <Stack
          direction='row'
          alignItems='center'
          boxSizing='border-box'
          justifyContent='flex-start'
          gap={2}
        >
          {iconAction && (
            <IconButton
              type='button'
              size='small'
              color='secondary'
              disableRipple
              disableFocusRipple
              disableTouchRipple
              onClick={() => iconAction(!iconState)}
            >
              <SvgIcon component={icon} fontSize='small' />
            </IconButton>
          )}
          {!iconAction && icon && <SvgIcon component={icon} fontSize='small' />}
          {showBackButton && (
            <Typography>
              <IconButton
                type='button'
                size='small'
                color='secondary'
                disableRipple
                disableFocusRipple
                disableTouchRipple
                onClick={handleBackClick}
                data-cy='page-header-back-button'
              >
                <SvgIcon component={ArrowBack} fontSize='small' />
              </IconButton>
            </Typography>
          )}
          <Typography
            variant={variant ? variant : 'h4'}
            data-cy='page-header-title'
          >
            {title}
          </Typography>
        </Stack>
        {children && (
          <Stack
            direction='row'
            boxSizing='border-box'
            gap={4}
            alignItems='center'
            justifyContent={childrenPosition || 'flex-end'}
          >
            {children}
          </Stack>
        )}
      </Stack>
      <Divider />
    </Box>
  )
}
